import { Box, useMediaQuery, useTheme } from '@mui/material';
import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';
import PersonalDataSection from './PersonalDataSection';
import ContactDataSection from './ContactDataSection';
import AdditionalDataSection from './AdditionalDataSection';

const SubscriberDialog = ({
  open,
  onClose,
  editMode,
  selectedSubscriber,
  onInputChange,
  onSelectChange,
  onSave,
  nationalities,
  maritalStatuses,
  ivaConditions,
  countries,
  provinces,
  departments,
  districts,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // Location logic has been moved to useSubscribersTable hook

  const commonProps = {
    selectedSubscriber,
    onInputChange,
    onSelectChange,
    isMobile,
    editMode,
  };

  return (
    <DialogContainer open={open} onClose={onClose} size={isMobile ? 'small' : 'fullWidth'}>
      <DialogTitle>{editMode ? 'Editar Suscriptor' : 'Agregar Suscriptor'}</DialogTitle>

      <DialogBody sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 3 }}>
        <Box sx={{ flex: 1 }}>
          <PersonalDataSection
            {...commonProps}
            nationalities={nationalities}
            maritalStatuses={maritalStatuses}
          />
        </Box>

        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'divider',
              mx: 2,
            }}
          />
        )}

        <Box sx={{ flex: 1 }}>
          <ContactDataSection
            {...commonProps}
            countries={countries}
            provinces={provinces}
            departments={departments}
            districts={districts}
          />
        </Box>

        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'divider',
              mx: 2,
            }}
          />
        )}

        <Box sx={{ flex: 1 }}>
          <AdditionalDataSection {...commonProps} ivaConditions={ivaConditions} />
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default SubscriberDialog;
